import { render, staticRenderFns } from "./DisableScriptModal.vue?vue&type=template&id=f49fbae0"
import script from "./DisableScriptModal.vue?vue&type=script&lang=js"
export * from "./DisableScriptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports